import React from "react";
import { Button, Divider, IconButton, List, ListItem, ListItemText, Paper } from "@material-ui/core";
import { Edit as EditIcon, Delete as DeleteIcon, Add } from "@material-ui/icons";

export default function PreguntasList({
  preguntas, selectedId, setSelectedId, handleEditarPregunta, eliminarPregunta, addQuestion, classes
}) {
  const formatNombre = (q) => {
    if (String(q?.valora) === "3") return q?.nombre ?? "";
    const n = Number(q?.valorb);
    if (Number.isFinite(n)) return `${n}. ${q?.nombre ?? ""}`;
    return q?.nombre ?? "";
  };

  const isTempQuestionId = (id) =>
    typeof id === "string" &&
    (id.startsWith("qtmp_") || Number.isNaN(Number(id)));

  return (
    <Paper className={classes.leftPaper}>
      <div className={classes.leftHeader}>
        <Button
          onClick={addQuestion}
          startIcon={<Add />}
          color="primary"
          variant="contained"
          fullWidth
        >
          Nueva pregunta
        </Button>
      </div>
      <Divider />
      <List dense>
        {(preguntas || [])
          .sort((a, b) => Number(a.valorb) - Number(b.valorb))
          .map((q) => {
            const esTemporal = isTempQuestionId(q.id);
            return (
              <ListItem
                key={q.id}
                className={classes.listItem}
                selected={q.id === selectedId}
                onClick={() => setSelectedId(q.id)}
                button
              >
                <ListItemText primary={formatNombre(q)} />
                <div className={classes.actionsRow}>
                  <IconButton
                    size="small"
                    disabled={esTemporal}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (esTemporal) return;
                      handleEditarPregunta(q);
                    }}
                    title={
                      esTemporal
                        ? "Guarda primero la pregunta para volver a editarla"
                        : "Editar"
                    }
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      eliminarPregunta(q.id);
                    }}
                    title="Eliminar"
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </div>
              </ListItem>
            );
          })}
      </List>
    </Paper>
  );
}
